/* eslint no-console:0 */

import ReactLoader from "../utils/react_loader";
import ReactUnloader from "../utils/react_unloader";
import NonreactLoader from "../utils/nonreact_loader";

document.addEventListener("turbolinks:load", ReactLoader);
document.addEventListener("turbolinks:load", NonreactLoader);
document.addEventListener("turbolinks:before-render", ReactUnloader);
